export {}

export const globalMethods: any = {}

// tag template literals
/** Removes indent */
// ignoreIndent = (ts: TemplateStringsArray, ...vs: Array<string>): string => {
// 	 let res = ''
// 	 for (let i = 0; i < ts.length; i++)
// 			res += ts[i] + (vs[i] || '')
// 	 return res.replace(/\n[\s]+/gi, '\n')
// }

// // lets color code our logs for readability
// const styles = {
//    quiet: 'color: #dd3291; padding: 1px 7px; border-radius: 4px'
// }
// cl.quiet = (...args: any) => cl.log(`%c${args.shift()}`, styles.quiet, ...args)
// cl.quietGroup = (...args: any) => {
//    cl.groupCollapsed(`%c${args.shift()}`, styles.quiet)
//    cl.log(...args)
//    cl.groupEnd()
// }

/** INFO.toArr() - parse obj values to an array
 *   fastest & prettiest
 */
// Object.defineProperty(Object.prototype, 'qArr', {
//    enumerable: false, // enum: true - breaks jquery.. eh
//    configurable: false,
//    writable: true,
//    value: function (k: any) {
//       let o = this,
//          ks = Object.keys(o),
//          a = new Array()
//       for (let i = 0; i < ks.length; i++) a[i] = k ? o[ks[i]][k] : o[ks[i]]
//       return a
//    }
// })

/** INFO.toSorted() - parse obj values to a sorted array
 *   specify dir (asc|des) - not really finished
 */
// Object.defineProperty(Object.prototype, 'qSorted', {
//    enumerable: false,
//    configurable: false,
//    writable: true,
//    value: function ({ dir = 'asc', key = 'value' }) {
//       let o = this,
//          ks = Object.keys(o),
//          a = new Array()
//       for (let i = 0; i < ks.length; i++) {
//          for (let j = i; j < ks.length; j++) {
//             if (o[ks[i]][key] > o[ks[j]][key]) {
//                let temp = o[ks[i]]
//                a[i] = o[ks[j]]
//                a[j] = temp
//             }
//          }
//          a.push(o[ks[i]])
//       }
//       return a
//    }
// })


/** INFO.toArr() - parse obj values to an array
 *   fastest & prettiest
 */
//  Object.defineProperty(Object.prototype, 'qKey', {

//       get() {
//         return this.key;
//       },
//       set(key) {
//         this.key = key;
//       }

// })


/** more performant reduce method for objects, ++ for a sprinkle of syntactic sugar */
// Object.defineProperty(Object.prototype, 'qReduce', {
//    enumerable: false, // enum: true - breaks jquery.. eh
//    configurable: false,
//    writable: true,
//    value(func: (acc: any, [k, v]: [k: string, v: any], i: number, o: { [key: string]: any }) => any, acc: any): any {

//       let o = this,
//          ks = Object.keys(o)
//       for (let i = 0; i < ks.length; i++) acc = func(acc, [ks[i], o[ks[i]]], i, o)
//       return acc
//    }
// })

// /** foreach for objects */
// Object.defineProperty(Object.prototype, 'qEach', {
//    enumerable: false, // enum: true - breaks jquery.. eh
//    configurable: false,
//    writable: false,
//    value(func: ([k, v]: [k: string, v: any], i: number, o: { [key: string]: any }) => void): void {
//       let o = this,
//          ks = Object.keys(o)
//       for (let i = 0; i < ks.length; i++) func([ks[i], o[ks[i]]], i, o)
//    }
// })




// // assert function inside proto?? will it work?
// Object.defineProperty(Object.prototype, 'assertDefinition', {
//    enumerable: false,
//    configurable: false,
//    writable: false,
//    value (this: unknown, message?: string): unknown | any {

//       if (!this) throw new Error(message || 'Unhandled error')
//       if (this) {
//          const foo = this
//          return foo
//       }
//    }
// })
